import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class componentName extends Component {
  render() {
    const { title, titleUrl } = this.props;
    return (
      <div>
        <div className="cc-toolbar">
          { title &&
          <div className="cc-toolbar__col">
            <h1 className="cc-toolbar__title">
             { titleUrl ?
              <Link to={titleUrl}>
                {title}
              </Link>
              :
              <span>{title}</span>
             }
            </h1>
          </div>
          }
          <div className="cc-toolbar__col">
            <Link to="/logout" style={{'color':'white'}}>Wyloguj</Link>
          </div>
        </div>
      </div>
    )
  }
};



// WEBPACK FOOTER //
// ./src/base/components/common/Toolbar.js